import type { OrganizationDetail } from 'models';
import { useCallback } from 'react';

type P = {
  nodeOrganizationId?: string;
  organization?: OrganizationDetail;
};

export const useCreateNodeOrganization = () =>
  useCallback(({ nodeOrganizationId, organization }: P) => {
    if (!nodeOrganizationId || !organization) {
      return undefined;
    }

    return {
      channelTags: organization.tags.map((tag) => ({ hashid: tag.id, name: tag.name })),
      id: nodeOrganizationId,
      name: organization.name,
      settings: {
        allowCustomChannels: organization.customChannels,
      },
    };
  }, []);
